import MenuWrapperFooter from "./ModuleWrapperFooter";

export default MenuWrapperFooter;